import { graphql } from '@/graphql/codegen';

export const registerParticipantMutationDocument = graphql(/* GraphQL */ `
  mutation registerParticipant($participant: RegisterInput!) {
    register(registerInput: $participant) {
      id
      email
    }
  }
`);
